import React from 'react';
import { ReactComponent as PencilIcon } from 'images/pencil.svg';
import { EditMode, EditModeOverlay, EditModeWrapper } from './EditChipStyles';

export const EditChip = () => {
  return (
    <EditModeWrapper>
      <EditModeOverlay />
      <EditMode>
        <PencilIcon />
        Edit mode
      </EditMode>
    </EditModeWrapper>
  );
};
